import { Inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { BaseFpxComponentState, BaseFpxFormHelper, HttpRequest } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { environment } from "src/environments/environment";
import { ResultPageComponent } from "./result-page.component";
import { HttpProviderService } from  '@fpx/core';
export class ResultPageState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  resultData: any;
  isAlreadyFav: boolean = false;
}

@Injectable()
export class ResultPageHelper extends BaseFpxFormHelper<ResultPageState>{
  private accountsModules: string[] = ['casa-accounts', 'deposits', 'loans'];
  private cardsModules: string[] = ['debit-card', 'credit-card'];
  private commonModules = new Map<any,any>()

  constructor(
    public _httpProvider : HttpProviderService,
    private _processShellService: ProcessShellService,
    private _router: Router,
    private _matDialog: MatDialog,
    private _commonService: CommonService,

    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(new ResultPageState());
    this._processShellService.setFooterVisible(false);
    this.state.resultData = this._commonService.isDesktop()?this.data:this._router.getCurrentNavigation()?.extras?.queryParams;
    this.commonModules.set('bill-payments','payments')
  }

  public doPreInit(): void {
    this._processShellService.formClassName = this._processShellService.formClassName + "result-info";
    this._processShellService.setFooterVisible(false);
  }

  public doDestroy(): void {
    this.state.isAlreadyFav = false;
    this._processShellService.resultIconData =  undefined;
    this._processShellService.formClassName = this._processShellService.formClassName.replace(' result-info', '');
  }

  iconClick(iconData){
    // TEMP FIX
    if(iconData?.icon == 'favourite'){
      if(this.state.isAlreadyFav){
        return
    }
      this.state.isAlreadyFav = true;
   
      this._processShellService.resultIconClick.emit({service:iconData?.service,resultData:this.state.resultData});
    }
  }

  onClose() {
    if (this.state.resultData && this.state.resultData.backNavPath) {
      let module = '';
      if (this.accountsModules.includes(this.state.resultData.backNavPath)) module = 'transactions';
      else if (this.cardsModules.includes(this.state.resultData.backNavPath)) module = 'cards';
      else module = this.state.resultData.backNavPath;

      const extras = this._processShellService.getInitialProcess();
      const additionalDetails = extras?.queryParams?.additionalDetails;
      this._processShellService.clearDraftProcess();
      this._commonService.isDesktop()?this._matDialog.closeAll():'';
      this._router.navigate(['home', module], {
        queryParams: additionalDetails?.queryParams,
        queryParamsHandling: 'preserve'
      });
    } else {
      this._matDialog.closeAll();
      this._router.navigate(['home']);
    }

  }

}
